import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueFormGenerator from 'vue-form-generator'
import Multiselect from 'vue-multiselect'
import fieldFile from './components/fields/fieldFile.vue'
import { TableComponent, TableColumn } from 'vue-table-component';
import ModuleLibrary from 'vfg-field-object'; 



// Install this library
Vue.component('table-component', TableComponent)
Vue.component('table-column', TableColumn)

Vue.use(BootstrapVue)
Vue.use(ModuleLibrary);
Vue.component('multiselect', Multiselect)
Vue.component('fieldFile', fieldFile)
Vue.use(VueFormGenerator)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  VueFormGenerator,
  Multiselect,
  render: h => h(App)
}).$mount('#app')